<template>
    <div>
        <div>
            <!-- Senior/NA discount -->
            <div>
                <div class="row">
                    <div class="col-md-1">
                        <base-checkbox v-model="show_senior_discount"/>
                    </div>
                    <div class="col-md-9">
                         <p>Enable SC/NA Discount</p>
                    </div>
                    <div class="col-md-2">
                        <a-switch
                        v-model="menus.override_enable_sc_discount"
                        :disabled="show_senior_discount != true" />
                    </div>
                </div>
                  <!-- will show if switch is true -->
                <div style="margin-left: 90px" class="my-4" v-if="menus.override_enable_sc_discount">
                    <div class="row">
                        <div class="col-md-2 ">
                            <base-checkbox v-model="menus.override_sc_discount_percent"/>
                        </div>
                        <div class="col-md-10" >
                            <base-input
                            type="number"
                            label="SC Discount"
                            v-model="menus.sc_discount_percent"
                            :disabled="menus.override_sc_discount_percent != true" /> 
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-2">
                            <base-checkbox
                            v-model="menus.override_is_senior_no_limit"
                            :disabled="true"/> 
                        </div>
                        <div class="col-md-8">
                            <p> Disable SC Limit </p>
                        </div>
                        <div class="col-md-2" style="padding-left: 0px">
                             <a-switch
                             v-model="menus.is_senior_nolimit"
                             :disabled="true" />
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-2">
                            <base-checkbox
                            v-model="menus.override_is_senior_vatex"
                            :disabled="true"/> 
                        </div>
                        <div class="col-md-8">
                            <p>SC/NA VAT-Exempt</p>
                        </div>
                        <div class="col-md-2" style="padding-left: 0px">
                             <a-switch
                             v-model="menus.is_senior_vatex"
                             :disabled="true" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- PWD discount -->
            <div >
                <div class="row">
                    <div class="col-md-1">
                        <base-checkbox v-model="show_pwd_discount"/>
                    </div>
                    <div class="col-md-9">
                         <p>Enable PWD Discount</p>
                    </div>
                    <div class="col-md-2">
                        <a-switch  
                        v-model="menus.override_enable_pwd_discount"
                        :disabled="show_pwd_discount != true"/>
                    </div>
                </div>
                
                <!-- will show if switch is true -->
                <div style="margin-left: 90px" class="my-4" v-if="menus.override_enable_pwd_discount">
                    <div class="row">
                        <div class="col-md-2 ">
                            <base-checkbox v-model="menus.override_pwd_discount_percent"/>
                        </div>
                        <div class="col-md-10" >
                            <base-input
                            type="number"
                            label="PWD Discount"
                            v-model="menus.pwd_discount_percent"
                            :disabled="menus.override_pwd_discount_percent != true" /> 
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-2"> 
                            <base-checkbox
                            v-model="menus.override_is_pwd_no_limit"
                            :disabled="true"/> 
                        </div>
                        <div class="col-md-8">
                            <p> Disable PWD Limit </p>
                        </div>
                        <div class="col-md-2" style="padding-left: 0px">
                            <a-switch
                            v-model="menus.is_pwd_nolimit"
                            :disabled="true"  />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <base-checkbox
                            v-model="menus.override_is_pwd_vatex"
                            :disabled="true"/> 
                        </div>
                        <div class="col-md-8">
                            <p>PWD VAT-Exempt </p>
                        </div>
                        <div class="col-md-2" style="padding-left: 0px">
                            <a-switch
                            v-model="menus.is_pwd_vatex"
                            :disabled="true" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- SP discount -->
            <div >
                <div class="row">
                    <div class="col-md-1">
                        <base-checkbox v-model="show_sp_discount"/>
                    </div>
                    <div class="col-md-9">
                         <p>Enable SP Discount</p>
                    </div>
                    <div class="col-md-2">
                        <a-switch  
                        v-model="menus.override_enable_sp_discount"
                        :disabled="show_sp_discount != true"/>
                    </div>
                </div>
                
                <!-- will show if switch is true -->
                <div style="margin-left: 90px" class="my-4" v-if="menus.override_enable_sp_discount">
                    <div class="row">
                        <div class="col-md-2 ">
                            <base-checkbox v-model="menus.override_sp_discount_percent"/>
                        </div>
                        <div class="col-md-10" >
                            <base-input
                            type="number"
                            label="SP Discount"
                            v-model="menus.sp_discount_percent"
                            :disabled="menus.override_sp_discount_percent != true" /> 
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-2"> 
                            <base-checkbox
                            v-model="menus.override_is_sp_no_limit"
                            :disabled="true"/> 
                        </div>
                        <div class="col-md-8">
                            <p> Disable SP Limit </p>
                        </div>
                        <div class="col-md-2" style="padding-left: 0px">
                            <a-switch
                            v-model="menus.is_sp_nolimit"
                            :disabled="true"  />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <base-checkbox
                            v-model="menus.override_is_sp_vatex"
                            :disabled="true"/> 
                        </div>
                        <div class="col-md-8">
                            <p>SP VAT-Exempt </p>
                        </div>
                        <div class="col-md-2" style="padding-left: 0px">
                            <a-switch
                            v-model="menus.is_sp_vatex"
                            :disabled="true" />
                        </div>
                    </div>
                </div>
            </div>

            
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

var component_x;
export default {
    
    data() {
    return {
        show_senior_discount: false,
        show_pwd_discount: false,
        show_sp_discount: false,
        override_enable_sc_discount: false,
        override_enable_sp_discount: false,
        override_enable_pwd_discount: false,
        override_sc_discount_percent: false,
        override_sp_discount_percent: false,
        override_pwd_discount_percent: false,
        override_is_pwd_no_limit: false,
        override_is_sp_no_limit: false,
        override_is_senior_no_limit: false, 
        override_is_senior_vatex: false,
        override_is_pwd_vatex: false,
        override_is_sp_vatex: false,

        // values to be override
        is_senior_vatex: false,
        is_pwd_vatex: false,
        is_sp_vatex: false,
        is_senior_nolimit: false,
        is_pwd_nolimit: false,
        is_sp_nolimit: false,
        sc_discount_percent: null,
        sp_discount_percent: null,
        pwd_discount_percent: null,

        menus: {},
        settingCode: null,     
        }
    },
    computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'categoriesOptions']),
    },
    mounted: async function() {
        component_x = this;
        this.settingCode = this.$attrs.settingCode
    },
    watch:{
        sc_discount_percent: function() {
            if(this.sc_discount_percent >= 20){
                this.menus.override_is_senior_no_limit = true;
                this.menus.is_senior_nolimit = true;
                this.menus.override_is_senior_vatex = true;
                this.menus.is_senior_vatex = true;
            }else{
                this.menus.override_is_senior_no_limit = false;
                this.menus.is_senior_nolimit = false;
                this.menus.override_is_senior_vatex = false;
                this.menus.is_senior_vatex = false;
            }
        },
        pwd_discount_percent: function() {
            if(this.pwd_discount_percent >= 20){
                this.menus.override_is_pwd_no_limit = true;
                this.menus.is_pwd_nolimit = true;
                this.menus.override_is_pwd_vatex = true;
                this.menus.is_pwd_vatex = true;
            }else{
                this.menus.override_is_pwd_no_limit = false;
                this.menus.is_pwd_nolimit = false;
                this.menus.override_is_pwd_vatex = false;
                this.menus.is_pwd_vatex = false;
            }
        },
        sp_discount_percent: function() {
            if(this.sp_discount_percent >= 20){
                this.menus.override_is_sp_no_limit = true;
                this.menus.is_sp_nolimit = true;
                this.menus.override_is_sp_vatex = true;
                this.menus.is_sp_vatex = true;
            }else{
                this.menus.override_is_sp_no_limit = false;
                this.menus.is_sp_nolimit = false;
                this.menus.override_is_sp_vatex = false;
                this.menus.is_sp_vatex = false;
            }
        },
        menus: {
            handler: async function() {
                this.sc_discount_percent = this.menus.sc_discount_percent
                this.is_senior_nolimit = this.menus.is_senior_nolimit
                this.is_senior_vatex = this.menus.is_senior_vatex
                this.pwd_discount_percent = this.menus.pwd_discount_percent
                this.is_pwd_nolimit = this.menus.is_pwd_nolimit
                this.is_pwd_vatex = this.menus.is_pwd_vatex
                this.sp_discount_percent = this.menus.pwd_discount_percent
                this.is_sp_nolimit = this.menus.is_pwd_nolimit
                this.is_sp_vatex = this.menus.is_pwd_vatex


                var configValues = {}
                configValues[this.settingCode] = this.menus
                component_x.$emit("changeValue", configValues)
            },
            deep: true
        }
    },
    
}

</script>

<style scoped>

</style>
